/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Button, Modal } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import CreateCampaignTriggerModal from "./CreateTriggerModal";
import ViewTriggerProgressModal from "./ViewProgressModal";
import { showErrorNotification, showSuccessNotification } from "../../../../utils/notification";
import { clamp } from "../../../../utils/responsiveHelpers";

const CampaignTriggersModal = ({
  campaignId,
  ROOT_URL,
  isModalOpen = false,
  senderEmailOptions = [],
  setIsModalOpen = () => {}
}) => {
  const TARGET_URL = "admin/bulk-notifications/campaign/trigger";

  const [triggersList, setTriggersList] = useState([]);
  const [mailingLists, setMailingLists] = useState([]);

  const [isTriggerCreationModalOpen, setIsTriggerCreationModalOpen] = useState(false);
  const [isTriggerProgressModalOpen, setIsTriggerProgressModalOpen] = useState(false);

  const [currentTriggerId, setCurrentTriggerId] = useState();
  const [currentTriggerProgress, setCurrentTriggerProgress] = useState({});

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchTriggersList = () => {
    axios
      .get(`${ROOT_URL}/${TARGET_URL}/list`, {
        params: {
          campaignId
        }
      })
      .then((res) => {
        const { triggers } = res.data;
        setTriggersList(triggers);
      })
      .catch((res) => {
        showErrorNotification(res);
      });
  };

  const fetchMailingListsForTriggerCreation = () => {
    axios
      .get(`${ROOT_URL}/${TARGET_URL}/fetch-mailing-lists`, {})
      .then((res) => {
        const { mailingLists } = res.data;
        setMailingLists(mailingLists);
      })
      .catch((res) => {
        showErrorNotification(res);
      });
  };

  const handleTriggerCreation = (formInput) => {
    axios
      .post(`${ROOT_URL}/${TARGET_URL}/create`, {
        inputParams: {
          ...formInput,
          campaignId
        }
      })
      .then(() => {
        fetchTriggersList();
        setIsTriggerCreationModalOpen(false);
      })
      .catch((res) => {
        showErrorNotification(res);
      });
  };

  const refreshTriggerStatus = (triggerId = undefined) => {
    axios
      .get(`${ROOT_URL}/${TARGET_URL}/refresh-status`, {
        params: {
          triggerId: currentTriggerId || triggerId
        }
      })
      .then((res) => {
        const { progress } = res.data;
        setCurrentTriggerProgress(progress);
        showSuccessNotification("Progress Refreshed successfully.");
      })
      .catch((res) => {
        showErrorNotification(res);
      });
  };

  const handleTriggerScheduling = (triggerId) => {
    axios
      .post(`${ROOT_URL}/${TARGET_URL}/schedule`, {
        triggerId
      })
      .then(() => {
        fetchTriggersList();
        showSuccessNotification(
          "Trigger is scheduled, please monitor the progress to check the current status."
        );
      })
      .catch((res) => {
        showErrorNotification(res);
      });
  };

  const handleTriggerArchival = (triggerId) => {
    axios
      .post(`${ROOT_URL}/${TARGET_URL}/archive`, {
        triggerId
      })
      .then(() => {
        fetchTriggersList();
      })
      .catch((res) => {
        showErrorNotification(res);
      });
  };

  const campaignTriggerColumns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Mailing List",
      dataIndex: "mailingList",
      key: "mailingList"
    },
    {
      title: "Sender Address",
      dataIndex: "senderEmail",
      key: "senderEmail"
    },
    {
      title: "Total Users",
      dataIndex: "targetedUsersCount",
      key: "targetedUsersCount"
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy"
    },
    {
      title: "State",
      dataIndex: "currentState",
      key: "currentState"
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (createdAt ? dayjs(createdAt).format("DD MMM YYYY | hh:mm") : "--")
    },
    {
      title: "Scheduled At",
      dataIndex: "scheduledAt",
      key: "scheduledAt",
      render: (scheduledAt) =>
        scheduledAt ? dayjs(scheduledAt).format("DD MMM YYYY | hh:mm") : "--"
    },
    {
      title: "Actions",
      key: "action",
      width: 50,
      render: (row) => (
        <div
          id="bulk_emailing_trigger_actions"
          style={{
            display: "flex",
            justifyContent: "space-around",
            gap: "5px",
            flexWrap: "wrap"
          }}
        >
          <>
            <Button
              type="primary"
              onClick={() => {
                setCurrentTriggerId(row.key);
                setIsTriggerProgressModalOpen(true);
              }}
            >
              View Progress
            </Button>
            <Button
              type="primary"
              disabled={!row.isActivationAllowed}
              onClick={() => {
                handleTriggerScheduling(row.key);
              }}
            >
              Schedule/Send
            </Button>
            <Button
              type="primary"
              danger
              onClick={() => {
                handleTriggerArchival(row.key);
              }}
            >
              Archive
            </Button>
          </>
        </div>
      )
    }
  ];

  useEffect(() => {
    fetchTriggersList();
  }, [campaignId]);

  useEffect(() => {
    fetchMailingListsForTriggerCreation();
  }, []);

  return (
    <Modal
      title="Triggers"
      open={isModalOpen}
      footer={[]}
      width={2500}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div
        style={{
          marginTop: "20px",
          marginLeft: clamp(12, 30),
          marginRight: clamp(12, 30)
        }}
      >
        <div
          style={{
            marginBottom: "10px"
          }}
        >
          <Button
            type="primary"
            onClick={() => {
              setIsTriggerCreationModalOpen(true);
            }}
          >
            Create Trigger
          </Button>
        </div>
        <br />
        <Table
          columns={campaignTriggerColumns}
          dataSource={triggersList}
          bordered
          pagination={false}
          scroll={{ x: "max-content" }}
        />

        {isTriggerCreationModalOpen && (
          <CreateCampaignTriggerModal
            mailingLists={mailingLists}
            isModalOpen={isTriggerCreationModalOpen}
            senderEmailOptions={senderEmailOptions}
            setIsModalOpen={setIsTriggerCreationModalOpen}
            handleTriggerCreation={handleTriggerCreation}
          />
        )}
        {isTriggerProgressModalOpen && (
          <ViewTriggerProgressModal
            triggerProgress={currentTriggerProgress}
            isModalOpen={isTriggerProgressModalOpen}
            setIsModalOpen={setIsTriggerProgressModalOpen}
            handleRefreshProgress={refreshTriggerStatus}
          />
        )}
      </div>
    </Modal>
  );
};

export default CampaignTriggersModal;
